import * as actionType from "./constants";
import { SET_DATES } from "../dateRangePicker/constants";

const initialState = {
  selected: [],
  transfer: [],
  selectedKeyword: "",
  availableKeyword: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DATES:
      return {
        ...state,
        selected: [],
        transfer: []
      };
    case actionType.SELECT_ROOMS:
      return selectRooms(state, action);

    case actionType.DESELECT_ROOMS:
      return deselectRooms(state, action);

    case actionType.CHECK_ROOM:
      return {
        ...state,
        transfer: state.transfer.concat(action.room)
      };

    case actionType.UNCHECK_ROOM:
      const roomIndex = getRoomIndex(action.room, state.transfer);
      return {
        ...state,
        transfer: state.transfer
          .slice(0, roomIndex)
          .concat(state.transfer.slice(roomIndex + 1))
      };

    case actionType.SET_SELECTED_KEYWORD:
      return {
        ...state,
        selectedKeyword: action.keyword
      };

    case actionType.SET_AVAILABLE_KEYWORD:
      return {
        ...state,
        availableKeyword: action.keyword
      };

    default:
      return state;
  }
};
const selectRooms = (state, action) => {
  let { selected } = state;
  for (let room of action.rooms) {
    const roomIndex = getRoomIndex(room, selected);
    if (roomIndex > -1) continue;
    selected = selected.concat(room);
  }
  return {
    ...state,
    selected: [...selected],
    transfer: []
  };
};

const deselectRooms = (state, action) => {
  let { selected } = state;
  for (let room of action.rooms) {
    const roomIndex = getRoomIndex(room, selected);
    if (roomIndex === -1) continue;
    selected = selected
      .slice(0, roomIndex)
      .concat(selected.slice(roomIndex + 1));
  }
  return {
    ...state,
    selected: [...selected],
    transfer: []
  };
};

const getRoomIndex = (room, rooms) => {
  return rooms.indexOf(rooms.find(r => r.roomId === room.roomId));
};



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/reducer.js